/**
 * Check if a value exists in a list of values
 *
 * @param {string[]} values list of values where we're going to check
 * @param {string} value value to check if it exists on the list of
 */
function includes(values: string[], value: string) {
  if (values && Array.isArray(values)) {
    return values.includes(value);
  }
  return false;
}

export default includes;
